/*
window.addEventListener("dx_init", function(){
    dx_invoicepreviews_scale();     
    window.addEventListener('resize', function(){
        dx_invoicepreviews_scale();
    }); 
    dx_invoicepreviews_init();
}); 
*/
if(window.parent==window){
    window.addEventListener("load", function(){
         dx_invoicepreviews_init();
    });     
} 
window.addEventListener("dx_invoicepreview_init", function(event){ 
    dx_invoicepreview_init(event.detail.block);
});
function dx_invoicepreviews_init(){
    var blocks = document.getElementsByClassName("wp-block-dx-invoicepreview");  
    for(var i = 0; i<blocks.length; i++){     
        dx_invoicepreview_init(blocks[i]);
    } 
}
function dx_invoicepreview_init(block){
    if(block.getAttribute("data-init")=="1"){       
        return;
    }
    block.setAttribute("data-init", "1"); 
    //dx_invoicepreview_draw(block, -1);

    //console.log("select");
    dx_invoicepreview_scale(block);     
    window.addEventListener('resize', function(){
        dx_invoicepreview_scale(block);
    }); 
    window.addEventListener("dx_invoice_select", dx_invoicepreview_onselect);
}

function dx_invoicepreview_onselect(event){
   
    let invoiceId = parseInt(event.detail.id);
    var blocks = document.getElementsByClassName("wp-block-dx-invoicepreview");  
    for(var i = 0; i<blocks.length; i++){     
        dx_invoicepreview_getData(blocks[i], invoiceId);
    } 
}

function dx_invoicepreview_getData(block, invoiceId){  

    let buttonInvoice = block.getElementsByClassName("wp-block-dx-invoicepreview-button-invoice")[0]; 
    buttonInvoice.style.display="none";
    let buttonEinvoice = block.getElementsByClassName("wp-block-dx-invoicepreview-button-einvoice")[0]; 
    buttonEinvoice.style.display="none";
    let buttonRecords = block.getElementsByClassName("wp-block-dx-invoicepreview-button-records")[0]; 
    buttonRecords.style.display="none";
 
    if(invoiceId == "-1"){
        block.getElementsByClassName("wp-block-dx-invoicepreview-address")[0].innerHTML=""; 
        block.getElementsByClassName("wp-block-dx-invoicepreview-title")[0].innerHTML=""; 
        block.getElementsByClassName("wp-block-dx-invoicepreview-date")[0].innerHTML=""; 
        block.getElementsByClassName("wp-block-dx-invoicepreview-text")[0].innerHTML=""; 
        block.getElementsByClassName("wp-block-dx-invoicepreview-signature")[0].style.opacity=0; 
        return;
    }

    
    const xhttp = new XMLHttpRequest();    
    xhttp.onload = function() {            
        if(xhttp.status == 200){  
            //console.log("----");
            //console.log(this.responseText);
            //console.log("----");
            let data=JSON.parse(this.responseText);            
            //console.log(data);   
            dx_invoicepreview_draw(block, invoiceId, data);
            //dx_invoicepreview_draw(block, invoiceId);
                     
        } else if(xhttp.status == 401){    
                           
        } else {     
            console.log(xhttp.status);          
            alert("XMLHttpRequest ERROR (Status "+xhttp.status+")");            
        }                      
    }        
    xhttp.onerror = function () {
        //console.log(this.responseText);
        alert("XMLHttpRequest ERROR");
    };       
   
    xhttp.open("POST", Dx.url.root+"/wp-content/plugins/dx/service/invoicepreview.php", true);
    xhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");   
    xhttp.send("action=getInvoiceData&id="+invoiceId+"&user="+Dx.keys.user+"&key="+Dx.keys.dxPro);

    
}    

function dx_invoicepreview_draw(block, invoiceId, data){  
   
    //PREVIEW 
    let paper = block.getElementsByClassName("wp-block-dx-invoicepreview-paper")[0]; 
    //paper.innerHTML="ivoiceId: "+invoiceId;

    //let image = new Image();
    //image.src=Dx.url.root+"/wp-content/plugins/dx/service/invoicepreview.php?action=getPDF&id="+invoiceId+"&user="+Dx.keys.user+"&key="+Dx.keys.dxPro;
    //window.open(Dx.url.root+"/wp-content/plugins/dx/service/invoicepreview.php?action=getImage&id="+invoiceId+"&user="+Dx.keys.user+"&key="+Dx.keys.dxPro, "_blank");  
    //window.open(Dx.url.root+"/wp-content/plugins/dx/service/test.pdf", "_blank");
    
    //HTML
    //let head = block.getElementsByClassName("wp-block-dx-invoicepreview-head")[0]; 
    let address = block.getElementsByClassName("wp-block-dx-invoicepreview-address")[0]; 
    let title = block.getElementsByClassName("wp-block-dx-invoicepreview-title")[0]; 
    let date = block.getElementsByClassName("wp-block-dx-invoicepreview-date")[0]; 
    let text = block.getElementsByClassName("wp-block-dx-invoicepreview-text")[0]; 
    //let foot = block.getElementsByClassName("wp-block-dx-invoicepreview-foot")[0]; 
    let signature = block.getElementsByClassName("wp-block-dx-invoicepreview-signature")[0]; 

    //head.innerHTML="<h2>digitalex GmbH</h2>Roßbergstraße 42<br/>70188 Stuttgart<br/>0711 / 411 488 4<br/>mail@digitalex.gmbh<br/>www.digitalex.gmbh";
    //foot.innerHTML="<b>digitalex GmbH</b> Geschäftsführer Alexander Frank | Amtsgericht Stuttgart HRB 755614 | UmsatzstrID DE305019617";
    
    

    
       
        

    address.innerHTML = data.address.split("\n").join("<br/>");  
    title.innerHTML = data.title;
    date.innerHTML = data.date;
    text.innerHTML = data.text+"<br/><br/>";

    //alert(data.projects);
    /*
    for(let i=0; i<projects.length; i++){
        //let projectData=client.projects.find(element => element.id == parseInt(projects[i]));
        if(projectData.unit=="h"){
            let amount=hours[i];                    
            //tableData.push({description:projectData.name, amount, unit:" h", unitPrice:projectData.price});
            //pdfFormData.entries.push({title: projectData.name, amount, unit:" h", unitPrice: projectData.price})
        } else {
            //tableData.push({description:projectData.name, amount:1, unit:"", unitPrice:projectData.price});
            //pdfFormData.entries.push({title: projectData.name, amount:1, unit:"", unitPrice: projectData.price})
        }                    
    }
        */

      let drawRow=function(rowData){
            let row=document.createElement("tr");        
            for(let c=0;c<rowData.length;c++){
                let cell=document.createElement("td");
                cell.innerHTML=rowData[c]
                row.appendChild(cell);
            }  
            return row;
        }
         let drawLine=function(double){  
            let row=document.createElement("tr");         
            for(let c=0;c<5;c++){
                let cell=document.createElement("td");            
                if(double){
                    cell.innerHTML="<hr class='double'/>";
                } else{
                    cell.innerHTML="<hr/>";
                }
                row.appendChild(cell);
            }  
            return row;   
        }
         let convertToEuro =function(value){
            let string = Math.round(value*100).toString();
            while(string.length<3){
                string+="0";
            }
            let euroString=string.substr(0, string.length-2)+","+string.substr(string.length-2, 2)+" €";
            return euroString;
        }
         let formatQuantity = function(value, unit){
            if(unit !== "h"){
                return value;
            }
            return Number(value).toLocaleString("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
         }

    let wrapper=document.createElement("div");
    let table=document.createElement("table");
    table.appendChild(drawRow(["Projekt", "Menge", "Einzelpreis", "Gesamtpreis"]));
    table.appendChild(drawLine());
    let netto=0;
    
    for(let r=0; r<data.projects.length; r++){
        //console.log(data.projects[0])
        let quantity = formatQuantity(data.projects[r].amount, data.projects[r].unit);
        table.appendChild(drawRow([data.projects[r].name, quantity+data.projects[r].unit, convertToEuro(data.projects[r].unitPrice), convertToEuro(data.projects[r].amount*data.projects[r].unitPrice)]));
        netto+=(data.projects[r].amount*data.projects[r].unitPrice);
    }
    
    table.appendChild(drawLine());
    table.appendChild(drawRow(["Summe (netto)", "", "", convertToEuro(netto)]));
    table.appendChild(drawRow(["zzgl 19% Umsatzsteuer", "", "", convertToEuro(netto*0.19)]));
    table.appendChild(drawLine());
    table.appendChild(drawRow(["<b>Gesamtbetrag</b>", "", "", "<b>"+convertToEuro(netto*1.19)+"</b>"]));      
    table.appendChild(drawLine(true));
    wrapper.appendChild(table);
    
    text.innerHTML += wrapper.innerHTML;

    text.innerHTML+="<br/>Ich bedanke mich für die gute Zusammenarbeit und bitte um Überweisung des Gesamtbetrages innerhalb der nächsten 14 Tage auf folgendes Konto bei der Holvi Bank:<br/><br/>";        
    text.innerHTML+="IBAN: DE23 1001 7997 4553 6424 72<br/>";        
    text.innerHTML+="BIC: HOLVDEB1<br/><br/>"; 
    text.innerHTML+="Mit freundlichen Grüßen<br/><br/>";

    signature.style.opacity=1;  


      
    //PDF
    let buttonInvoice = block.getElementsByClassName("wp-block-dx-invoicepreview-button-invoice")[0]; 
    buttonInvoice.style.display="inline-block";
    buttonInvoice.onclick=function(){
        window.open(Dx.url.root+"/wp-content/plugins/dx/service/invoicepreview.php?action=getInvoicePDF&id="+invoiceId+"&user="+Dx.keys.user+"&key="+Dx.keys.dxPro, "_blank");  
    }
    let buttonEinvoice = block.getElementsByClassName("wp-block-dx-invoicepreview-button-einvoice")[0]; 
    buttonEinvoice.style.display="inline-block";
    buttonEinvoice.onclick=function(){
        window.open(Dx.url.root+"/wp-content/plugins/dx/service/invoicepreview.php?action=getEInvoicePDF&id="+invoiceId+"&user="+Dx.keys.user+"&key="+Dx.keys.dxPro, "_blank");  
    }
    let buttonRecords = block.getElementsByClassName("wp-block-dx-invoicepreview-button-records")[0]; 
    buttonRecords.style.display="inline-block";
    buttonRecords.onclick=function(){
        window.open(Dx.url.root+"/wp-content/plugins/dx/service/invoicepreview.php?action=getRecordsPDF&id="+invoiceId+"&user="+Dx.keys.user+"&key="+Dx.keys.dxPro, "_blank");  
    }

}  
/*
function dx_invoicepreviews_scale(){
    var blocks = document.getElementsByClassName("wp-block-dx-invoicepreview");  
    for(var i = 0; i<blocks.length; i++){     
        dx_invoicepreview_scale(blocks[i]);
    } 
  
} 
    */   

function dx_invoicepreview_scale(block){
    console.log("scale");
    let box = block.getElementsByClassName("wp-block-dx-invoicepreview-box")[0]; 
    let paper = block.getElementsByClassName("wp-block-dx-invoicepreview-paper")[0]; 
    var scale = Math.min( 
        box.offsetWidth / 1000, 
        box.offsetHeight / 1412.8 
    );              
    paper.style.transform="scale("+scale+")";
}







